import React from 'react'
import { useTranslation } from 'react-i18next'

import { Spinner } from '../../../App/Components'
import {
  Dashboard,
  DashBoardHeading,
  DashBoardItem,
  OutOfDashBoard,
} from '../../../App/Components/Container/DashBoard/Dashboard'
import { useAppSelector } from '../../../App/Hooks/reduxHooks'
import {
  BottomNavigationSetup,
  ProfileDashboardHeading,
} from '../../Components'
import { headingStyle } from '../Profile/style'

export const ProfileSettings = () => {
  const { t } = useTranslation()

  const currentUser = useAppSelector(state => state.users.currentUser)

  if (!currentUser) {
    return <Spinner />
  }

  return (
    <Dashboard itemColumnCount={1} headingStyle={headingStyle}>
      <DashBoardHeading>
        <ProfileDashboardHeading />
      </DashBoardHeading>
      <DashBoardItem style={{ alignItems: 'flex-start' }}>
        <p>{currentUser.email || t('No e-mail address')}</p>
        <h2>{t('Password forgotten')}</h2>
        <p>{t('Ask your manager to reset your password.')}</p>
      </DashBoardItem>
      <OutOfDashBoard key={'profileOutOfDashboard'}>
        <BottomNavigationSetup currentUser={currentUser} />
      </OutOfDashBoard>
    </Dashboard>
  )
}
